import { apiCall } from "./store-util";

export const getTokiPonaWords = () => {
    return apiCall("get-all-toki-pona-words").then((response: any) => {
        const res = JSON.parse(response.toString());
        return res;
    });
}